import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { branchInfoTable } from './branchInfoTable';
import { MatDialog } from '@angular/material/dialog';
import { AddBranchComponent } from './add-branch/add-branch.component';


@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
  @ViewChild('rightPortion') scrollableDiv: ElementRef;
  activeIndex: number = 0;
  totalSteps: number = 4;
  progressBar: number = 25;
  firstStep: boolean=true;
  secondStep: boolean=false;
  thirdStep: boolean=false;
  fourthStep: boolean=false;
  dataSource: MatTableDataSource<branchInfoTable> = new MatTableDataSource<branchInfoTable>();
  displayedColumns: string[] = ['branchNumber', 'branchNameEn', 'branchNameAr', 'numberOfStudentsPerBranch', 'bankName', 'bankAccountName', 'bankAccountNumber','accountCurrency','SWIFTcode'];
  fileCommercial: File | null = null;
  fileTax: File | null = null;
  fileAuthorized: File | null = null;
  review: boolean = false;

  steps = [
    { text: 'Business Information',textAr:'بيانات الشركة', number: '1' },
    { text: 'Contact Information',textAr:'بيانات التواصل', number: '2' },
    { text: 'Bank Account Information',textAr:'بيانات الحسابات البنكية الخاصة بالتسوية', number: '3' },
    { text: 'Required Documents',textAr:'المستندات المطلوبة', number: '4' }
  ];

  constructor(
  public dialog: MatDialog ,

  ) {

    const data = [
      {
        branchNumber: 1,
        branchNameEN: 'New Cairo',
        branchNameAR: 'نيو',
        numberOfStudentsPerBranch: 20,
        bankName: 'CIB',
        bankAccountName: 'HELLO WORLD',
        bankAccountNumber: 1234,
        accountCurrency: 'EGP',
        SWIFTcode: 2244
      },
      {
        branchNumber: 1,
        branchNameEN: 'New Cairoooo',
        branchNameAR: 'نيو',
        numberOfStudentsPerBranch: 20000,
        bankName: 'CIBBBBBB',
        bankAccountName: 'HHHHHHHELLO WORLD',
        bankAccountNumber: 12345433,
        accountCurrency: 'EGPPPPPP',
        SWIFTcode: 2244354904
      }
    ];
    this.dataSource = new MatTableDataSource(data);
   }

  ngOnInit(): void {


  }
  onNext() {

    this.scrollUp();
    if (this.activeIndex < this.steps.length - 1) {
      this.activeIndex++;
    }
    if (this.progressBar < 100) {
      this.progressBar += 25;
    }
    console.log(this.activeIndex)
  }


  onBack() {
    this.scrollUp();
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
    if (this.progressBar > 25) {
      this.progressBar -= 25;
    }
  }
  scrollUp() {

    const divElement: HTMLElement = this.scrollableDiv.nativeElement;
    divElement.scrollTop = 0;
    window.scrollTo({ top: 0, behavior: 'smooth' });

  }
  openAddBranchDialog(){
    const dialogRef = this.dialog.open(AddBranchComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  onFileSelected(event: any, variableName: string) {
    const file = event.target.files[0];
    if (file) {
      this[variableName] = file;
      console.log(`File Commercial selected: ${this.fileCommercial}`);
      console.log(`File Tax selected: ${this.fileTax}`);
      console.log(`File Authorized selected: ${this.fileAuthorized}`);


    }
  }
  deleteFile(variableName: string) {
    this[variableName] = null;
  }
  reviewMode() {
    this.review=true;
  }
  onBackFromReview(){
    this.review=false;
  }



}
